import { render, staticRenderFns } from "./HowItWorksBlock.vue?vue&type=template&id=450c6b8e&scoped=true&"
import script from "./HowItWorksBlock.vue?vue&type=script&lang=js&"
export * from "./HowItWorksBlock.vue?vue&type=script&lang=js&"
import style0 from "./HowItWorksBlock.vue?vue&type=style&index=0&id=450c6b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450c6b8e",
  null
  
)

export default component.exports